import styled from "styled-components"

const StyledFooter = styled.footer`
  background-color: ${(props) => props.theme.d_color_gradients.d_dark};
`
const GoToHead = styled.div`
  color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const FooterLinks = styled.div`
  border-right: 1px solid ${(props) => props.theme.a_color_gradients.a_light};
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`
const FooterBottom = styled.ul`
  & li > a {
    color: ${(props) => props.theme.a_color_gradients.a_medium};
  }
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { StyledFooter, GoToHead, FooterLinks, FooterBottom }
